import { formataAliquota } from "./util.js";
import { converter } from "../../../masks/masks";
export default class Nfse {
  constructor(
    _id,
    empresa,
    dtEmissaoNfe,
    numeroNfe,
    vlrCredito,
    vlrServico,
    ISSRetido,
    codServico,
    codVerificacao,
    aliqServico,
    statusNFe,
    origem,
    tipo,
    opcaoSimples,
    numLote,
    numRPS,
    serieRPS,
    tipoRPS,
    dtEmissaoRPS,
    cnpjCpf,
    razao,
    insc,
    tribNfe,
    vlrISS,
    discriminacao,
    pathPdf,
    pathPdfMotor,
    gzipPath,
    customValues,
    statusErp,
    PIS,
    COFINS,
    CSLL,
    INSS,
    IR,
    codLei,
    lei,
    statusEmissao,
    razaoTomador,
    inscPrestador,
    emissaoMotor,
    dataServico,
    codMun,
    cnpjCpfTomador,
    cnpjCpfPrestador,
    statusDES,
    erroDES,
    erroEmissao,
    data_erp,
    status_escrituracao,
    id_fluig,
    log_statusErpDois,
    statusErpDois,
    log_statusErp,
    log_escrituracao,
    pdv,
    numero_pdv,
    data_pdv,
    nome_municipio,
    simples_nacional,
    posFechamento,
    numeroPedido,
    valorTotalRecebido,
    provedor,
    documento,
    tipoTomador,
    nomeArquivo
  ) {
    // let convertedDate = dataServico.substring(0,10);
    // convertedDate = convertedDate.split('-').reverse().join('/');
    let serviceDate;
    if (dataServico) {
      const currentServiceDate = new Date(dataServico);
      if (origem != 'MotorV2'){
        serviceDate = new Date(currentServiceDate.getTime() + 86400000);
      }else{
        serviceDate = new Date(currentServiceDate.getTime());
      }
    } else {
      serviceDate = "";
    }

    (this.dtEmissaoNfe = dtEmissaoNfe ? new Date(dtEmissaoNfe) : ""),
      (this.numeroNfe = numeroNfe),
      (this.vlrCredito = vlrCredito ? parseFloat(vlrCredito) : parseFloat(0)),
      (this.vlrServico = parseFloat(vlrServico)),
      (this.ISSRetido = ISSRetido),
      (this.codServico = codServico),
      (this.codVerificacao = codVerificacao),
      // this.aliqServico = parseFloat(aliqServico) == 0 ? parseFloat(aliqServico).toFixed(2) : parseFloat(aliqServico);
      // (this.aliqServico = aliqServico ? (parseFloat(aliqServico) * 100).toFixed(2) : ''),
      (this.aliqServico = formataAliquota(aliqServico));
    (this.statusNFe = statusNFe),
      (this.origem = origem),
      (this.tipo = tipo),
      (this.opcaoSimples = opcaoSimples),
      (this.numRPS = numRPS),
      (this.serieRPS = serieRPS),
      (this.numLote = numLote),
      (this.tipoRPS = tipoRPS),
      (this.dtEmissaoRPS = dtEmissaoRPS ? new Date(dtEmissaoRPS) : ""),
      (this.cnpjCpf = cnpjCpf),
      (this.razao = razao),
      (this.insc = insc),
      (this.tribNfe = tribNfe),
      (this.vlrISS = vlrISS),
      (this.discriminacao = discriminacao),
      (this.pathPdf = pathPdf),
      (this.pathPdfMotor = pathPdfMotor),
      (this.gzipPath = gzipPath),
      (this.customValues = customValues),
      (this._id = _id),
      (this.statusErp = statusErp),
      (this.empresa = empresa),
      (this.PIS = PIS),
      (this.COFINS = COFINS),
      (this.CSLL = CSLL),
      (this.INSS = INSS),
      (this.IR = IR),
      (this.codLei = codLei),
      (this.nome_municipio = nome_municipio ? nome_municipio : '' ),
      (this.simples_nacional = simples_nacional ? simples_nacional.descricao : '' ),
      (this.lei = lei),
      (this.statusEmissao = statusEmissao),
      (this.razaoTomador = razaoTomador),
      (this.inscPrestador = inscPrestador),
      (this.emissaoMotor = emissaoMotor),
      (this.dataServico = serviceDate),
      (this.codMun = codMun),
      (this.cnpjCpfTomador = cnpjCpfTomador),
      (this.cnpjCpfPrestador = cnpjCpfPrestador),
      (this.statusDES = statusDES),
      (this.erroDES = erroDES),
      (this.erroEmissao = erroEmissao),
      (this.log_escrituracao = log_escrituracao),
      (this.data_erp = converter(data_erp)),
      (this.status_escrituracao = status_escrituracao),
      (this.id_fluig = id_fluig),
      (this.log_statusErpDois = log_statusErpDois),
      (this.statusErpDois = statusErpDois),
      (this.log_statusErp = log_statusErp),
      (this.pdv = pdv),
      (this.numero_pdv = numero_pdv),
      (this.data_pdv = data_pdv),
      (this.posFechamento = posFechamento),
      (this.numeroPedido = numeroPedido),
      (this.valorTotalRecebido = valorTotalRecebido),
      (this.documento = documento),
      (this.provedor = provedor),
      (this.tipoTomador = tipoTomador),
      (this.nomeArquivo = nomeArquivo);
  }
}



// WEBPACK FOOTER //
// ./src/domain/notas/nfse/Nfse.js